import { FunctionComponent } from 'react';
import KlarnaBadge from 'dibs-icons/exports/legacy/KlarnaBadgeFilled';

import styles from './styles/CheckoutKlarnaView.scss';

export const CheckoutKlarnaView: FunctionComponent = () => {
    return <KlarnaBadge className={styles.logo} />;
};
